<script>
  import SearchResultImg from './SearchResultImg.svelte'

  export let item;
  export let type;
</script>

<li class="results__list-item list-group-item">
  {#if type == 'vendor'}
    <a class="results__link" href="/make/{item.slug}">
      <div>
        <SearchResultImg url={item.img_url} />
        <span>{item.title}</span>
      </div>
      <div>
        <i class="results__arrow-icon bi bi-arrow-return-left"></i>
      </div>
    </a>
  {:else}
    <a class="results__link" href="{item.model_url}">
      <div class="d-flex align-items-center">
        <SearchResultImg url={item.img_url} />
        <span>
          <span class="fw-normal">{item.vendor_title}</span>
          <br class="line-break-sm">
          <span>{item.title}<span>
        </span>
      </div>
      <div>
        <i class="results__arrow-icon bi bi-arrow-return-left"></i>
      </div>
    </a>
  {/if}
</li>

<style lang="scss">
  .results {
    &__list-item {
      background: white !important;
      padding: 0;
    }

    &__link {
      &:first-child {
        border-top-left-radius: inherit;
        border-top-right-radius: inherit;
      }

      &:last-child {
        border-bottom-left-radius: inherit;
        border-bottom-right-radius: inherit;
      }

      display: flex !important;
      justify-content: space-between;
      align-items: center;
      color: black;
      display: block;
      padding: 10px;
      font-weight: bold;
      font-size: 1rem;

      &:hover {
        text-decoration: none;
        background: #0067ff;
        color: white;

        .results__arrow-icon {
          display: inline;
        }
      }
    }

    &__arrow-icon {
      font-size: 1.1rem;
      display: none;
    }
  }

  .line-break-sm {
    @media (min-width: 450px) {
      display: none;
    }
  }
</style>